import React from "react";

import cx from "classnames";

import { Button } from "~/ui";
import type { ButtonProps } from "~/ui/button";
import IconButton, { type IconButtonProps } from "~/ui/legacy/IconButton";

import styles from "./SideBarItem.module.css";

type HeaderProps = React.PropsWithChildren<React.HTMLProps<HTMLHeadElement>>;

export function Header({ children, className, ...rest }: HeaderProps) {
	return (
		<header className={cx(styles.header, className)} {...rest}>
			{children}
		</header>
	);
}

Header.displayName = "SideBarItem.Header";

type TitleProps = React.PropsWithChildren<React.HTMLProps<HTMLHeadingElement>>;

export function Title({ children, className, ...rest }: TitleProps) {
	return (
		<h2 className={cx(styles.title, className)} {...rest}>
			{children}
		</h2>
	);
}

Title.displayName = "SideBarItem.Title";

type HeaderButtonProps = React.PropsWithChildren<ButtonProps>;

export function HeaderButton({ children, className, ...rest }: HeaderButtonProps) {
	return (
		<Button variant="secondary" className={cx(styles.headerButton, className)} {...rest}>
			{children}
		</Button>
	);
}

type HeaderIconButtonProps = IconButtonProps;

export const HeaderIconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(function HeaderIconButton(
	{ className, ...rest }: HeaderIconButtonProps,
	ref,
) {
	return <IconButton ref={ref} className={cx(styles.headerIconButton, className)} {...rest} />;
});

HeaderButton.displayName = "SideBarItem.HeaderButton";

type BodyProps = React.PropsWithChildren<React.HTMLProps<HTMLDivElement>>;

const Body = React.forwardRef<HTMLDivElement, BodyProps>(({ children, className, ...rest }, ref) => {
	return (
		<div ref={ref} className={cx(styles.body, className)} {...rest}>
			{children}
		</div>
	);
});

Body.displayName = "SideBarItem.Body";

type SideBarItemProps = React.PropsWithChildren<React.HTMLProps<HTMLElement>>;

export class SideBarItem extends React.Component<SideBarItemProps & { expandToBottom?: boolean }> {
	static Header = Header;
	static Title = Title;
	static HeaderButton = HeaderButton;
	static HeaderIconButton = HeaderIconButton;
	static Body = Body;

	constructor(props: SideBarItemProps) {
		super(props);
	}

	render() {
		const { children, className, expandToBottom, ...rest } = this.props;
		return (
			<section className={cx(styles.wrapper, { [styles.expandToBottom]: expandToBottom }, className)} {...rest}>
				{children}
			</section>
		);
	}
}
